<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>{{ title }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>顧客情報</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <client-search
          v-if="$attrs.isCreate"
          :has-set="client_haset"
          @setClient="setClient($event)">
        </client-search>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*顧客コード"
          v-model="item.client.cd"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="業種分類"
          :items=$store.getters.industryCodes
          :readonly="!$attrs.isCreate"
          item-text="label"
          item-value="id"
          v-model="item.client.industrycode"
          :error-messages="validation_errors.client.industrycode"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="検索用カナ"
          v-model="item.client.search_kana"
          :error-messages="validation_errors.client.search_kana"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*会社名または個人名"
          v-model="item.client.name1"
          :error-messages="validation_errors.client.name1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="部署名"
          v-model="item.client.name2"
          :error-messages="validation_errors.client.name2"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="課名"
          v-model="item.client.name3"
          :error-messages="validation_errors.client.name3"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="名前"
          v-model="item.client.name4"
          :error-messages="validation_errors.client.name4"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="敬称"
          :items="$store.getters.nameTitles"
          item-text="name"
          item-value="id"
          v-model="item.client.name_title"
          :error-messages="validation_errors.client.name_title"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*郵便番号"
          prepend-inner-icon="mdi-magnify"
          v-model="item.client.zipcode"
          :error-messages="validation_errors.client.zipcode"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="*都道府県"
          :items=$store.getters.prefectures
          item-text="name"
          item-value="id"
          v-model="item.client.prefecture"
          :error-messages="validation_errors.client.prefecture"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*住所1"
          v-model="item.client.address1"
          :error-messages="validation_errors.client.address1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="住所2"
          v-model="item.client.address2"
          :error-messages="validation_errors.client.address2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="電話番号"
          v-model="item.client.tel"
          :error-messages="validation_errors.client.tel"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="FAX"
          v-model="item.client.fax"
          :error-messages="validation_errors.client.fax"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.client.note"
          :error-messages="validation_errors.client.note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.note"
          :error-messages="validation_errors.note"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="*発行日"
              readonly
              v-on="on"
              v-model="item.publish_date"
              :error-messages="validation_errors.publish_date"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="item.publish_date"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="納品書番号"
          v-model="item.cd"
          readonly
          :error-messages="validation_errors.cd"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="*納品日"
              readonly
              v-on="on"
              v-model="item.date_of_issue"
              :error-messages="validation_errors.date_of_issue"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="item.date_of_issue"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="合計金額"
          v-model="item.sum_price"
          readonly
          :error-messages="validation_errors.sum_price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="消費税"
          readonly
          v-model="item.sum_tax"
          :error-messages="validation_errors.sum_tax"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>納品内容</v-subheader>
      </v-col>
    </v-row>
    <template>
    <v-row v-if="validation_errors.non_field_errors">
      <v-col>
        <span class="error--text text-caption" v-for="error in validation_errors.non_field_errors" :key="error">*{{ error }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              納品内容を追加する
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">納品内容</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-select
                      label="製品カテゴリ"
                      :items="$store.getters.deliveryItemCategories"
                      item-text="name"
                      item-value="id"
                      v-model="detailitem.deliveryitemcategory_id"
                      :error-messages="detailitem.errors.deliveryitemcategory_id"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-select
                      label="商品"
                      :items="deliveryitems"
                      item-text="name"
                      item-value="id"
                      v-model="detailitem.deliveryitem_id"
                      :error-messages="detailitem.errors.deliveryitem_id"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-select
                      label="商品明細"
                      :items="deliveryitemdetails"
                      item-text="name"
                      item-value="id"
                      v-model="detailitem.deliveryitemdetail_id"
                      :error-messages="detailitem.errors.deliveryitemdetail_id"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    sm="6"
                  >
                    <v-text-field
                      label="*品名"
                      v-model="detailitem.title"
                      :error-messages="detailitem.errors.title"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="*数量"
                      v-model="detailitem.amount"
                      :error-messages="detailitem.errors.amount"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="*単価"
                      v-model="detailitem.unit_price"
                      :error-messages="detailitem.errors.unit_price"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-select
                      label="*消費税区分"
                      :items=$store.getters.taxTypes
                      item-text="name"
                      item-value="id"
                      v-model="detailitem.taxtype_id"
                      :error-messages="validation_errors.taxtype_id"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="金額"
                      v-model="detailitem.price"
                      :error-messages="detailitem.errors.price"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="saveDetail"
                    color="primary">一時保存</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="cancelDetail"
                    color="default">キャンセル</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="deleteDetail"
                    class="red white--text" 
                    v-if="detailitem.counter || detailitem.id"
                    >削除</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    </template>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="item.adsdeliverydetail_set"
          :items-per-page="50"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            v-if="item.has_error"
            small
            color="pink lighten-2"
            class="white--text"
            @click="editDetailitem(item)"
          >
            編集
          </v-btn>
          <v-btn
            v-else
            small
            color="default"
            @click="editDetailitem(item)"
          >
            編集
          </v-btn>
        </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="3"
      ><v-btn class="red white--text" @click="save">保存する</v-btn></v-col>
      <v-col
        cols="12"
        md="3"
        sm="4"
        v-if="!$attrs.isCreate">
        <v-btn class="red white--text" @click="download">納品書ダウンロード</v-btn></v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClientSearch from '@/components/ClientSearch'

export default {
  components: {
    'client-search': ClientSearch,
  },
  data() {
    return {
      title: '',
      item: {
        'client': {},
        'adsdeliverydetail_set': [],
      },
      validation_errors: {
        'client': {},
        'adsdeliverydetail_set': [],
      },
      input_address: false,
      dialog: false,
      shipping_dialog: false,
      headers: [
        {text: "品名", value: "title"},
        {text: "個数", value: "amount"},
        {text: "単価", value: "unit_price"},
        {text: "金額", value: "price"},
        {text: "操作", value: "action"},
      ],
      detailitemDefaultErrors: {
      },
      detailitemDefault: {
        errors: {
        },
        has_error: false,
      },
      detailitem: {
        errors: {},
      },
      detailitem_counter: 1,

      // 配送製品プルダウン用
      deliveryitems: [],
      deliveryitemdetails: [],
      footer_props: {
      },
      client_haset: false,
    }
  },
  created() {
    if (this.$attrs.isCreate) {
      this.title = "納品書登録"
      if (this.$route.params.invoice_id) {
        this.getInvoice();
      }
    } else {
      this.title = "納品書編集"
      this.getItem();
    }
    this.clearDetailitem();
    this.setSumTax();
  },
  watch: {
    'detailitem.deliveryitemcategory_id': async function(val) {
      await this.loadDeliveryItems(val);
    },
    'detailitem.deliveryitem_id': async function(val) {
      await this.loadDeliveryItemDetails(val);
    },
    'item.adsdeliverydetail_set': {
      handler: function(val) {
        let sum_price = 0;
        //let sum_tax = 0;
        let sum_amount = 0;
        val.forEach((element) => {
          sum_price += element.price;
          //sum_tax += element.tax;
          sum_amount += element.sum_amount;
        });
        this.item.sum_price = sum_price;
        //this.item.sum_tax = sum_tax;
        this.item.sum_amount = sum_amount;
        this.setSumTax();
      },
      deep: true,
    },
    'detailitem': {
      handler: function() {
        this.detailitem.price = this.detailitem.amount * this.detailitem.unit_price;
        console.log(this.detailitem.taxtype_id)
        if (this.detailitem.taxtype_id == 1) {
          this.detailitem.tax = Math.floor(this.detailitem.price * 0.1); // TODO: マスター参照
        } else {
          this.detailitem.tax = 0;
        }
      },
      deep: true,
    },
  },
  methods: {
    setClient(item) {
      this.item.client = item;
      if (item.id) {
        this.client_haset = true;
      } else {
        this.client_haset = false;
      }
    },
    setSumTax() {
      if (this.item.adsdeliverydetail_set.length > 0) {
        if (this.item.adsdeliverydetail_set[0].taxtype_id == 1) {
          this.item.sum_tax = Math.floor(this.item.sum_price * 0.1)
        } else {
          this.item.sum_tax = 0
        }
      } else {
        this.item.sum_tax = 0
      }
    },
    clearDetailitem() {
      this.detailitem = Object.assign({}, this.detailitemDefault)
      if (this.item.adsdeliverydetail_set.length > 0) {
        this.detailitem.taxtype_id = this.item.adsdeliverydetail_set[0].taxtype_id
      }
    },
    async loadDeliveryItems(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/`,
            {
              params: {'deliveryitemcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.deliveryitems = response.data.results;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.deliveryitems = []
      }
    },
    async loadDeliveryItemDetails(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${val}/details/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.deliveryitemdetails = response.data;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.deliveryitemdetails = [];
      }
    },
    editDetailitem(item) {
      this.detailitem = item;
      this.dialog = true;
    },
    saveDetail() {
      if (! this.detailitem.id && ! this.detailitem.counter) {
        this.detailitem.counter = this.detailitem_counter;
        this.detailitem_counter++;
        this.item.adsdeliverydetail_set.push(this.detailitem);
      } else {
        let target_idx = null;
        this.item.adsdeliverydetail_set.forEach((element, idx) => {
          if ( (this.detailitem.id && element.id == this.detailitem.id)
            || (this.detailitem.counter && element.counter == this.detailitem.counter)) {
              target_idx = idx
            }
          }
        );

        if (target_idx !== null) {
          this.item.adsdeliverydetail_set[target_idx] = this.detailitem;
        }
      }
      this.item.adsdeliverydetail_set.forEach((element) => {
        element.taxtype_id = this.detailitem.taxtype_id;
      })
      this.clearDetailitem();
      this.dialog = false;
    },
    deleteDetail() {
      let target_idx = null;
      this.item.adsdeliverydetail_set.forEach((element, idx) => {
        if ( (this.detailitem.id && element.id == this.detailitem.id)
          || (this.detailitem.counter && element.counter == this.detailitem.counter)) {
            target_idx = idx
          }
        }
      );
      if (target_idx !== null) {
        this.item.adsdeliverydetail_set.splice(target_idx, 1);
      }
      this.clearDetailitem();
      this.dialog = false;
    },
    cancelDetail() {
      this.clearDetailitem();
      this.dialog = false;
    },
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/ads/adsdeliveries/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        const data = response.data;
        this.item = data;
        this.item.adsdeliverydetail_set.forEach((elem) => {
          elem.errors = Object.assign({}, this.deliveryitemDefaultErrors);
        });
      } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
      }
    },
    async getInvoice() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/ads/adsinvoices/${this.$route.params.invoice_id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        const data = response.data;
        this.item = data;
        this.item.adsdeliverydetail_set = data.adsinvoicedetail_set
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
      }
    },
    async save() {
      if (this.$attrs.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      let response = null;
      try {
        response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/ads/adsdeliveries/`,
          {...this.item, ...this.computed_item},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.validation_errors = {
          'client': {},
          'adsdeliverydetail_set': [],
        };
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
        if (!this.validation_errors.client) {
          this.validation_errors.client = {};
        }
        if (!this.validation_errors.adsdeliverydetail_set) {
          this.validation_errors.adsdeliverydetail_set = [];
        } else {
          this.bindDetailitemError(this.validation_errors.adsdeliverydetail_set);
        }
        return;
      }
      this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
      this.$router.push({'name': 'EditAdsDelivery', 'params': {id: response.data.id}});
    },
    async update() {
      try {
        await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/ads/adsdeliveries/${this.$route.params.id}/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
        this.validation_errors = {
          'client': {},
          'adsdeliverydetail_set': [],
        };
        await this.getItem();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.response.data;
        if (!this.validation_errors.client) {
          this.validation_errors.client = {};
        }
        if (!this.validation_errors.adsdeliverydetail_set) {
          this.validation_errors.adsdeliverydetail_set = [];
        } else {
          this.bindDetailitemError(this.validation_errors.adsdeliverydetail_set);
        }
      }
      await this.getItem();
    },
    bindDetailitemError(errors) {
      this.item.adsdeliverydetail_set.forEach((element, idx) => {
        const error = errors[idx];
        console.log(error)
        if (error && Object.keys(error).length) {
          element.has_error = true;
          element.errors = Object.assign(Object.assign({}, this.detailitemDefaultErrors), error);
        } else {
          element.has_error = false;
          element.errors = Object.assign({}, this.detailitemDefaultErrors);
        }
        console.log(element.has_error)
      });
    },
    async download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/ads/adsdeliveries/${this.$route.params.id}/pdf/`,
          {
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "deliverynotice.pdf");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>
